export default __webpack_public_path__ + "static/media/icon-logout.9b56c80e.svg";